module.exports = __webpack_public_path__ + "img/img25.aad8310f.png";